<div class="headline">
    {{preview}}
</div>
<ng-container *ngFor="let sub of subTitles" class="sub-title">
    <div class="sub-title">
        <span class="sub">
            {{sub.type}}
        </span>
        <span class="main">
            {{sub.value}}
        </span>
    </div>
</ng-container>